import script from "./ValidatorsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatorsList.vue?vue&type=script&setup=true&lang=js"

import "./ValidatorsList.vue?vue&type=style&index=0&id=af493312&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af493312"]])

export default __exports__